// @ts-check

import { toggleBooleanAttribute } from "../utilities/attributes";
import { get, getAll, getById } from "../utilities/querySelector";

const header = getById( 'site-header' );
const burger = get( '.burgerBox', header );
const menu = get( '.site-header__menu', header );

menu?.setAttribute( 'aria-hidden', 'true' );
burger?.setAttribute( 'aria-expanded', 'false' );

burger?.addEventListener( 'click', toggleMenu );

const depotListTrigger = get( '[href="#depot-list"]', header );
const depotList = getById( 'depot-list' );
const depotHoursListTrigger = get( '[href="#christmas-hours-list"]', header );
const depotHoursList = getById( "christmas-hours-list" );

depotListTrigger?.addEventListener( 'click', ( e ) => {
  e.preventDefault();
  depotListTrigger.toggleAttribute( 'data-active' );
  depotList?.toggleAttribute( 'data-active' );
} );

depotHoursListTrigger?.addEventListener( 'click', ( e ) => {
  e.preventDefault();
  depotHoursListTrigger.toggleAttribute( 'data-active' );
  depotHoursList?.toggleAttribute( 'data-active' );
} );


function toggleMenu() {
  if ( burger instanceof HTMLElement ) {
    burger.toggleAttribute( 'data-active' );
    toggleBooleanAttribute( 'aria-expanded', burger );
  }
  if ( menu instanceof HTMLElement ) {
    menu.toggleAttribute( 'data-active' );
    toggleBooleanAttribute( 'aria-hidden', menu );
  }
}

const submenuToggles = getAll( '[data-sub-menu-toggle]', menu );
submenuToggles.forEach( setUpSubmenuToggle );

function setUpSubmenuToggle( toggle ) {
  const submenu = toggle.closest( '.menu-item' )?.querySelector( '.sub-menu' );
  toggle.addEventListener( 'click', ( e ) => {
    e.preventDefault();
    submenu.toggleAttribute( 'data-active' );
  } );
}


const dismissPromoBanner = document.querySelector('#site-header .promo-banner .icon-close');

dismissPromoBanner?.addEventListener('click', dismissPromoBannerIcon);

function dismissPromoBannerIcon() {
  document.body?.classList.add('banner-dismissed');
  sessionStorage.setItem('banner-closed', 'true');
}